import React, { useState, useEffect, useContext, createContext } from 'react';

// UPDATED: Use the /coins/markets endpoint
// It returns an array, even for one id. Includes price and % change.
const API_URL = 'https://api.coingecko.com/api/v3/coins/markets?vs_currency=usd&ids=bitcoin&price_change_percentage=24h';
const REFETCH_INTERVAL = 60000; // Refetch every 60 seconds (60000 ms)

// 1. Create the Context - Add priceChange24h to the default shape
const BitcoinPriceContext = createContext({
    price: null,
    loading: true,
    error: null,
    priceChange24h: null, // Add state for 24h percentage change
});

// 2. Create the Provider Component
export const BitcoinPriceProvider = ({ children }) => {
    const [price, setPrice] = useState(null);
    const [priceChange24h, setPriceChange24h] = useState(null); // New state
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // Renamed function to reflect fetching more data
    const fetchBitcoinData = async () => {
        // setLoading(true); // Optional: Show loading on refresh
        setError(null);

        try {
            const response = await fetch(API_URL);
            if (!response.ok) {
                throw new Error(`Failed to fetch: ${ response.status } ${ response.statusText }`);
            }
            const data = await response.json();

            // UPDATED: Response is an array, get the first element
            if (Array.isArray(data) && data.length > 0) {
                const bitcoinData = data[0];

                // Validate the structure of the response object
                if (bitcoinData && typeof bitcoinData.current_price === 'number' && typeof bitcoinData.price_change_percentage_24h === 'number') {
                    setPrice(bitcoinData.current_price);
                    setPriceChange24h(bitcoinData.price_change_percentage_24h);
                } else {
                    throw new Error('Invalid API response format within the data array');
                }
            } else {
                throw new Error('Invalid API response format: Expected an array with data');
            }
        } catch (e) {
            console.error("Error fetching Bitcoin data:", e);
            setError(e.message || 'An unknown error occurred');
            // Clear potentially stale data on error
            // setPrice(null);
            // setPriceChange24h(null);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchBitcoinData(); // Use updated function name
        const intervalId = setInterval(fetchBitcoinData, REFETCH_INTERVAL); // Use updated function name
        return () => clearInterval(intervalId);
    }, []);

    // UPDATED: Add priceChange24h to the value object
    const value = {
        price,
        loading,
        error,
        priceChange24h, // Provide the 24h change
    };

    return (
        <BitcoinPriceContext.Provider value={value}>
            {children}
        </BitcoinPriceContext.Provider>
    );
};

// 3. Create the Custom Hook - No changes needed here
export const useBitcoinPrice = () => {
    const context = useContext(BitcoinPriceContext);
    if (context === undefined) {
        throw new Error('useBitcoinPrice must be used within a BitcoinPriceProvider');
    }
    return context;
};